import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-646b1300"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "template-import-form" }
const _hoisted_2 = {
  key: 1,
  class: "template-import-form_search"
}
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "template-import-form_plate-button" }
const _hoisted_5 = { class: "template-import-form_sidebar" }

import { TirPmSearchInput } from "tir-pm-search-input";
import { computed, PropType, provide, ref } from "vue";
import { ParametersTemplateModel } from "../models";
import {
  TaskParameterModel,
  TaskParameterTypeEnum,
  SidebarMenu,
  ChooseProjectDropdown,
} from "@/components";
import { TaskParametersTemplatesList } from "../components";
import { projectInjectKey } from "@/inject-keys";
import { ProjectModel } from "@/models";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmPlate,
  TirPmStatusBudge,
} from "tir-components";
import { ProjectsService } from "../adapter-service";
import { ArrowUturnUpIcon } from "tir-style-system/icons/outline";

/**API сервис */

export default /*#__PURE__*/_defineComponent({
  __name: 'template-import-form',
  props: {
  /**Тип настройки */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
},
  emits: ["import", "back"],
  setup(__props, { emit }) {

const props = __props;

const apiService = new ProjectsService();

/**Параметры */

/**События */


/**Поисковой запрос */
const search = ref("");
/**Состояние отображения сообщения */
const isShowMessage = ref<Boolean>(true);
/**Список шаблонов */
const templates = ref<ParametersTemplateModel[]>([]);

/**Выбранный проект */
const selectedProject = ref<ProjectModel>();
/**Id рабочей области */
const namespaceId = ref<string>();
/**Id папки */
const groupId = ref<number>();
/**Id очереди */
const queueId = ref<string>();
/**Загрузка сущностей */
const isLoading = ref(false);

/**Экспорт выбранного проекта */
provide(projectInjectKey, selectedProject);

/**Текст "Найдено шаблонов: n" */
const searchedTemplatesText = computed(() => `Найдено очередей: ${templates.value.length}`);
/**Подпись к полю ввода */
const searchLabel = computed(() => {
  let param = "";
  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      param = "статусам";
      break;
    case TaskParameterTypeEnum.Priority:
      param = "приоритетам";
      break;
    case TaskParameterTypeEnum.Tag:
      param = "тегам";
      break;
    case TaskParameterTypeEnum.Type:
      param = "типам";
      break;
    case TaskParameterTypeEnum.Difficulty:
      param = "сложностям";
      break;
  }
  return `Поиск по ${param} и очередям`;
});

/**Текст в сообщении */
const messageText = computed(() => {
  let param = "";
  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      param = "статусы";
      break;
    case TaskParameterTypeEnum.Priority:
      param = "приориты";
      break;
    case TaskParameterTypeEnum.Tag:
      param = "теги";
      break;
    case TaskParameterTypeEnum.Type:
      param = "типы";
      break;
    case TaskParameterTypeEnum.Difficulty:
      param = "сложности";
      break;
  }
  return param;
});

/**Отображать только рабочие области */
const isOnlyNamespaces = computed(
  () => props.type == TaskParameterTypeEnum.Difficulty || props.type == TaskParameterTypeEnum.Type,
);
/**Виден ли блок с поиском */
const isSearchVisible = computed(
  () => props.type == TaskParameterTypeEnum.Status || props.type == TaskParameterTypeEnum.Priority,
);
/**Виден ли сайдбар */
const isSidebarVisible = computed(
  () => !!selectedProject.value && props.type != TaskParameterTypeEnum.Tag,
);
/**Видна ли кнопка, для выходя из импорта */
const isBackButtonVisible = computed(
  () =>
    props.type == TaskParameterTypeEnum.Type ||
    props.type == TaskParameterTypeEnum.Difficulty ||
    props.type == TaskParameterTypeEnum.Tag,
);

/**Импортировать параметры очереди */
const importParameters = (template: ParametersTemplateModel) => {
  emit("import", template.ParsedData);
};
/**Выбор проекта */
const selectProject = (project: ProjectModel) => {
  selectedProject.value = project;
  if (props.type == TaskParameterTypeEnum.Tag) {
    getEntityParameters(project.Id);
  } else {
    clearIds();
  }
};
/**Получение параметров рабочей области */
const getNamespaceParameters = async (_namespaceId?: string) => {
  await getEntityParameters(undefined, _namespaceId);
};
/**Получение параметров папки */
const getGroupParameters = async (_namespaceId?: string, _groupId?: number) => {
  await getEntityParameters(undefined, _namespaceId, _groupId);
};
/**Получение параметров очереди */
const getQueueParameters = async (_namespaceId?: string, _queueId?: string) => {
  await getEntityParameters(undefined, _namespaceId, undefined, _queueId);
};
/**Получение параметров сущности */
const getEntityParameters = async (
  _projectId?: number,
  _namespaceId?: string,
  _groupId?: number,
  _queueId?: string,
) => {
  isLoading.value = true;

  if (_namespaceId || _groupId || _queueId) {
    clearIds();
    namespaceId.value = _namespaceId;
    groupId.value = _groupId;
    queueId.value = _queueId;
  }

  const searchRequest = isSearchVisible.value ? search.value : "";
  const response = await apiService.GetEntityParameters(
    props.type,
    searchRequest,
    _projectId,
    namespaceId.value,
    groupId.value,
    queueId.value,
  );

  if (response.IsSuccess) templates.value = response.Value;

  isLoading.value = false;
};
/**Очистка id сущности */
const clearIds = () => {
  namespaceId.value = undefined;
  groupId.value = undefined;
  queueId.value = undefined;
};
/**Изменение состояния отображения сообщения */
const changeIsShow = () => {
  isShowMessage.value = !isShowMessage.value;
};
/**Обновить список сущностей по поиску */
const updateSearch = async () => {
  if (queueId.value) {
    await getQueueParameters();
  } else if (groupId.value) {
    await getGroupParameters();
  } else if (namespaceId) {
    await getNamespaceParameters();
  }
};

/**Выйти из импорта */
const goBack = () => {
  emit("back");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isBackButtonVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "template-import-form_back",
          onClick: goBack
        }, [
          _createVNode(_unref(ArrowUturnUpIcon)),
          _createTextVNode(" Назад ")
        ]))
      : _createCommentVNode("", true),
    (isSearchVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(TirPmSearchInput), {
            modelValue: search.value,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              updateSearch
            ],
            "is-small": "",
            class: "template-import-form_search_input",
            placeholder: "",
            isLoading: isLoading.value,
            isWithPopup: false,
            label: searchLabel.value
          }, null, 8, ["modelValue", "isLoading", "label"]),
          _createElementVNode("div", {
            textContent: _toDisplayString(searchedTemplatesText.value),
            class: "template-import-form_search_text"
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(TirPmPlate), {
      isShow: isShowMessage.value,
      variant: "attention",
      positionControlAddons: "bottom",
      "is-bordered": "",
      class: "template-import-form_plate"
    }, {
      leftAddon: _withCtx(() => [
        _createVNode(_unref(TirPmStatusBudge), {
          statusIconType: "alert",
          statusColor: "alert"
        })
      ]),
      subtitleSlot: _withCtx(() => [
        _createTextVNode("В текущий список добавится набор " + _toDisplayString(messageText.value=="статусы"?"статусов":"приоритетов") + " из выбранной очереди. Ранее созданные и не использованные в тикетах " + _toDisplayString(messageText.value) + " из списка удалятся", 1)
      ]),
      controlsAddons: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(TirPmButton), {
            variant: _unref(TirPmButtonVariantEnum).SecondaryState,
            size: _unref(TirPmButtonSizeEnum).Small,
            onClick: changeIsShow
          }, {
            default: _withCtx(() => [
              _createTextVNode("Понятно")
            ]),
            _: 1
          }, 8, ["variant", "size"])
        ])
      ]),
      _: 1
    }, 8, ["isShow"]),
    _createVNode(_unref(TaskParametersTemplatesList), {
      "is-import": "",
      type: __props.type,
      templates: templates.value,
      onSelect: importParameters
    }, null, 8, ["type", "templates"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(ChooseProjectDropdown), {
        "model-value": selectedProject.value,
        "onUpdate:modelValue": selectProject
      }, null, 8, ["model-value"]),
      (isSidebarVisible.value)
        ? (_openBlock(), _createBlock(_unref(SidebarMenu), {
            key: 0,
            "is-static": "",
            "only-namespaces": isOnlyNamespaces.value,
            hideProjectInfo: "",
            width: 256,
            onOpenNamespace: getNamespaceParameters,
            onOpenGroup: getGroupParameters,
            onOpenQueue: getQueueParameters
          }, null, 8, ["only-namespaces"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})